export function summarizeSelectedTenants(names) {
  const normalizedNames = Array.isArray(names)
    ? names.filter((name) => typeof name === 'string' && name.trim()).map((name) => name.trim())
    : []
  const summary = { names: normalizedNames, count: normalizedNames.length }

  if (normalizedNames.length === 0) return { kind: 'empty', ...summary }
  if (normalizedNames.length === 1) return { kind: 'single', ...summary, name: normalizedNames[0] }

  return { kind: 'multiple', ...summary }
}
